export default __webpack_public_path__ + "static/media/lose@3x.5bda4d64.png";